import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useGameStore } from '../store/gameStore';
import { cardAPI } from '../services/api';
import './TeamBuilder.css';
function TeamBuilder() {
    const { teams, userCards, setTeams, setCurrentTeam, currentTeam, setCurrentPage } = useGameStore();
    const [newTeamName, setNewTeamName] = useState('');
    const [selectedSlots, setSelectedSlots] = useState([]);
    const [creating, setCreating] = useState(false);
    const handleCreateTeam = async () => {
        if (!newTeamName.trim()) {
            alert('Please enter a team name');
            return;
        }
        if (selectedSlots.length !== 6) {
            alert('Please select exactly 6 cards for your team');
            return;
        }
        setCreating(true);
        try {
            const response = await cardAPI.createTeam(newTeamName, selectedSlots);
            const newTeams = [...teams, response.data];
            setTeams(newTeams);
            setCurrentTeam(response.data);
            setNewTeamName('');
            setSelectedSlots([]);
            alert('Team created successfully!');
        }
        catch (error) {
            alert('Failed to create team');
        }
        finally {
            setCreating(false);
        }
    };
    const handleAutoCreateTeam = async () => {
        setCreating(true);
        try {
            const response = await cardAPI.autoCreateTeam('自動強隊');
            const newTeams = [...teams, response.data.team];
            setTeams(newTeams);
            setCurrentTeam(response.data.team);
            setNewTeamName('');
            setSelectedSlots([]);
            alert('✨ 自動隊伍已建立！\n系統已幫你選擇了最強的6張卡牌');
        }
        catch (error) {
            alert('Failed to auto-create team. Do you have enough cards?');
        }
        finally {
            setCreating(false);
        }
    };
    const handleAutoFillTeam = async () => {
        try {
            const response = await cardAPI.getAutoTeamSuggestion();
            setSelectedSlots(response.data.cardIds);
            setNewTeamName('自動推薦隊伍');
            alert(`✨ 已自動選擇6張最強卡牌！\n現在可以點擊"建立隊伍"來保存`);
        }
        catch (error) {
            alert('Failed to get auto team suggestion');
        }
    };
    const toggleCardSlot = (cardId) => {
        const newSlots = [...selectedSlots];
        const index = newSlots.indexOf(cardId);
        if (index > -1) {
            newSlots.splice(index, 1);
        }
        else if (newSlots.length < 6) {
            newSlots.push(cardId);
        }
        setSelectedSlots(newSlots);
    };
    const selectTeam = async (team) => {
        setCurrentTeam(team);
        try {
            await cardAPI.updateTeam(team.id, { is_active: true });
        }
        catch (error) {
            // Still keep the team selected locally even if API fails
        }
    };
    return (_jsxs("div", { className: "team-builder", children: [_jsx("div", { className: "builder-header", children: _jsx("h2", { children: "\uD83D\uDC65 Team Builder" }) }), _jsxs("div", { className: "builder-content", children: [_jsxs("div", { className: "team-creation", children: [_jsx("h3", { children: "Create New Team" }), _jsx("div", { className: "form-group", children: _jsx("input", { type: "text", placeholder: "Team name", value: newTeamName, onChange: (e) => setNewTeamName(e.target.value), disabled: creating }) }), _jsxs("div", { className: "team-slots", children: [_jsxs("div", { className: "slots-info", children: [_jsxs("span", { children: [selectedSlots.length, "/6 cards selected"] }), selectedSlots.length >= 4 && _jsx("span", { className: "ready-badge", children: "Ready for battle!" })] }), _jsx("div", { className: "selected-cards", children: selectedSlots.map((cardId) => {
                                            const card = userCards.find((c) => c.id === cardId);
                                            return card ? (_jsxs("div", { className: "slot-card", children: [_jsx("span", { children: card.name }), _jsx("button", { onClick: () => toggleCardSlot(cardId), className: "remove-btn", children: "\u00D7" })] }, `${cardId}-slot`)) : null;
                                        }) })] }), _jsxs("div", { style: { display: 'flex', gap: '10px', marginTop: '15px' }, children: [_jsx("button", { className: "btn-create-team", onClick: handleCreateTeam, disabled: creating || selectedSlots.length !== 6, children: creating ? 'Creating...' : 'Create Team' }), _jsx("button", { className: "btn-create-team", onClick: handleAutoCreateTeam, disabled: creating, style: { backgroundColor: '#06d6a0' }, children: "\u26A1 Auto Create Team" })] }), _jsx("button", { className: "btn-create-team", onClick: handleAutoFillTeam, style: { marginTop: '10px', backgroundColor: '#ff8c42' }, disabled: creating, children: "\uD83D\uDCA1 Auto Fill Cards (Suggestion Only)" })] }), _jsxs("div", { className: "team-selection", children: [_jsx("h3", { children: "Your Teams" }), _jsx("div", { className: "teams-list", children: teams.length === 0 ? (_jsx("p", { className: "empty-state", children: "No teams created yet" })) : (teams.map((team) => (_jsxs("div", { className: `team-card ${currentTeam?.id === team.id ? 'active' : ''}`, onClick: () => selectTeam(team), children: [_jsx("h4", { children: team.name }), _jsxs("p", { className: "card-count", children: [team.card_slots?.length || 0, " cards"] }), currentTeam?.id === team.id && _jsx("div", { className: "active-badge", children: "Active" })] }, team.id)))) })] }), _jsxs("div", { className: "card-picker", children: [_jsx("h3", { children: "Available Cards" }), _jsx("div", { className: "cards-pool", children: userCards.map((card) => (_jsxs("div", { className: `pool-card ${selectedSlots.includes(card.id) ? 'selected' : ''}`, onClick: () => toggleCardSlot(card.id), children: [_jsxs("div", { className: "card-info", children: [_jsx("h5", { children: card.name }), _jsx("span", { className: "attr", children: card.attribute })] }), _jsxs("div", { className: "card-stats", children: [_jsxs("span", { children: ["ATK: ", card.base_damage] }), _jsxs("span", { children: ["HP: ", card.base_hp] })] }), selectedSlots.includes(card.id) && _jsx("div", { className: "selected-indicator", children: "\u2713" })] }, card.id))) })] })] }), _jsx("button", { className: "btn-back", onClick: () => setCurrentPage('home'), children: "\u2190 \u8FD4\u56DE\u4E3B\u83DC\u55AE" })] }));
}
export default TeamBuilder;
